import { RES_DATA, ORDERS } from '@store/constants';
import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';
import { getErrorMessage, toErrorData } from '@utils';
import { ORDER_RESOURCE, ALERT_STATUS_TYPE } from '@constants';

export const getOrderById =
  ({ orderId }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ORDERS.GETTING_ORDER_BY_ID
      });

      const { data } = await api.orders.getOrderDetailsSidebar(orderId);

      return dispatch({
        type: ORDERS.GET_ORDER_BY_ID_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      return dispatch({
        type: ORDERS.GET_ORDER_BY_ID_FAILURE,
        payload: error
      });
    }
  };

export const getOrderByIdWithResource =
  ({ orderId, orderResource }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ORDERS.GETTING_ORDER_BY_ID
      });

      let data;
      if (orderResource === ORDER_RESOURCE.GOMS_SERVICE) {
        const response = await api.orders.getGomsOrderDetailsSidebar(orderId);
        data = response.data;
      } else {
        const response = await api.orders.getOrderDetailsSidebar(orderId);
        data = response.data;
      }

      return dispatch({
        type: ORDERS.GET_ORDER_BY_ID_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      return dispatch({
        type: ORDERS.GET_ORDER_BY_ID_FAILURE,
        payload: error
      });
    }
  };

export const clearOrderDetails = () => ({
  type: ORDERS.CLEAR_ORDER_DETAILS
});

export const getOrders =
  ({ query, orderType, pageNo, pageSize = 10, refresh = false }) =>
  async (dispatch) => {
    try {
      if (!query?.length && !orderType?.length) {
        return dispatch({
          type: RES_DATA.SEARCH_ORDERS_FAILURE,
          payload: toErrorData({
            message: 'search query and order type can not be empty'
          })
        });
      }

      dispatch({
        type: RES_DATA.SEARCHING_ORDERS,
        payload: {
          pageNo,
          refresh
        }
      });
      const { data } = await api.search.ordersV2(
        query,
        orderType,
        pageNo,
        pageSize
      );

      return dispatch({
        type: RES_DATA.SEARCH_ORDERS_SUCCESS,
        payload: data
      });
    } catch (error) {
      return dispatch({
        type: RES_DATA.SEARCH_ORDERS_FAILURE,
        payload: {
          error,
          pageNo
        }
      });
    }
  };

export const getGomsOrders =
  ({ query, orderType, pageNo, pageSize = 10, refresh = false }) =>
    async (dispatch) => {
      try {
        if (!query?.length && !orderType?.length) {
          return dispatch({
            type: RES_DATA.SEARCH_GOMS_ORDERS_FAILURE,
            payload: toErrorData({
              message: 'search query and order type can not be empty'
            })
          });
        }

        dispatch({
          type: RES_DATA.SEARCHING_GOMS_ORDERS,
          payload: {
            pageNo,
            refresh
          }
        });
        const { data } = await api.search.gomsOrders(
          query,
          orderType,
          pageNo,
          pageSize
        );

        return dispatch({
          type: RES_DATA.SEARCH_GOMS_ORDERS_SUCCESS,
          payload: data
        });
      } catch (error) {
        return dispatch({
          type: RES_DATA.SEARCH_GOMS_ORDERS_FAILURE,
          payload: {
            error,
            pageNo
          }
        });
      }
    };


export const updateOrderMetadata =
  ({
    orderId,
    note,
    flag,
    successMessage,
    failureMessage,
    onSuccess,
    onFinish
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ORDERS.UPDATING_ORDER_METADATA
      });

      const { data } = await api.orders.updateOrderMetadata({
        orderId,
        details: note,
        flag
      });

      onSuccess(); //trigger modal close

      dispatch(setAlert({ title: successMessage, status: 'success' }));

      dispatch({
        type: ORDERS.UPDATE_ORDER_METADATA_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: failureMessage,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      dispatch({
        type: ORDERS.UPDATE_ORDER_METADATA_FAILURE,
        payload: error
      });
    } finally {
      onFinish();
    }
  };
 // TODO:: Merge this and Appserver order metadata api into single method
  export const updateGomsOrderMetadata =
  ({
    orderId,
    note,
    flag,
    successMessage,
    failureMessage,
    onSuccess,
    onFinish
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ORDERS.UPDATING_ORDER_METADATA
      });

      const { data } = await api.orders.updateGomsOrderMetadata({
        orderId,
        details: note,
        flag
      });

      onSuccess(); //trigger modal close

      dispatch(setAlert({ title: successMessage, status: 'success' }));

      dispatch({
        type: ORDERS.UPDATE_ORDER_METADATA_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: failureMessage,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      dispatch({
        type: ORDERS.UPDATE_ORDER_METADATA_FAILURE,
        payload: error
      });
    } finally {
      onFinish();
    }
  };

export const getLuluOrders = (searchReqData) => async (dispatch) => {
  try {
    dispatch({
      type: RES_DATA.SEARCHING_LULU_ORDERS
    });

    const { data } = await api.search.luluOrders(searchReqData);

    return dispatch({
      type: RES_DATA.SEARCH_LULU_ORDERS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch(
      setAlert({
        title: getErrorMessage({
          error,
          genericMessage: 'Failed to get Lulu order: ' + searchReqData?.query
        }),
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    return dispatch({
      type: RES_DATA.SEARCH_LULU_ORDERS_FAILURE,
      payload: error
    });
  }
};

export const getOrderTransferChecks =
  ({ orderId, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.orders.getOrderTransferChecks({ orderId });
      onSuccess && onSuccess(data);
    } catch (error) {
      console.error(error?.message);
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export function getTxnMonitoringByFulfillmentId({ fulfillmentId }) {
  return async (dispatch) => {
    try {
      const { data } = await api.orders.getTxnMonitoringByFulfillmentId({
        fulfillmentId
      });
      return data;
    } catch (error) {
      if (error.status !== 404) {
        dispatch(
          setAlert({
            title: `${error.message}`,
            status: ALERT_STATUS_TYPE.ERROR
          })
        );
      }
      throw error;
    }
  };
}

export const getProviderEntityDetails =
  ({ fulfillmentId }) =>
  async (dispatch) => {
    try {
      const { data } = await api.orders.getProviderEntityDetails({
        fulfillmentId
      });
      return data;
    } catch (error) {
      if (error.status !== 404) {
        dispatch(
          setAlert({
            title: `${error.message}`,
            status: ALERT_STATUS_TYPE.ERROR
          })
        );
      }
      throw error;
    }
  };

export const reviewFulfillmentProvider = ({
    fulfillmentId,
    payload,
    onSuccess,
    onComplete
}) => async (dispatch) => {
    try {
        const { data } = await api.orders.reviewFulfillmentProvider({
            fulfillmentId,
            payload
        });

        dispatch(
          setAlert({
            title: `Review for fulfillment - ${fulfillmentId}, successfully submitted!`,
            status: ALERT_STATUS_TYPE.SUCCESS
          })
        );

        onSuccess && onSuccess();

        return data;
    } catch (error) {
        if (error.status !== 404) {
            dispatch(
                setAlert({
                    title: `${error.message}`,
                    status: ALERT_STATUS_TYPE.ERROR
                })
            );
        }
        throw error;
    } finally {
        onComplete && onComplete();
    }
};


export const getPendingOrderReceipts =
  ({
    orderId,
    pageNumber,
    pageSize,
    startDate,
    endDate,
    receiptStatus,
    onComplete,
    onSuccess
  }) =>
  async (dispatch) => {
    try {
      const { data } = await api.orders.getNotReviewedOrderReceipts({
        pageNumber,
        pageSize,
        orderId,
        startDate,
        endDate,
        receiptStatus
      });
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const acceptOrderReceipt =
  ({ receiptId, paymentReferenceId, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.orders.acceptOrderReceipt({
        receiptId,
        paymentReferenceId
      });
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const rejectOrderReceipt =
  ({ receiptId, rejectionNote, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.orders.rejectOrderReceipt({
        receiptId,
        rejectionNote
      });
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const getOrderReceiptsByOrderId =
  ({ orderId, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.orders.getOrderReceiptsByOrderId({ orderId });
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const gomsSearchOrders =
  ({ query, orderType, userId, page, pageSize, onSuccess, onComplete, onError }) =>
  async (dispatch) => {
    try {
      const { data } = await api.orders.gomsSearchOrders({
        query,
        orderType,
        userId,
        page,
        pageSize
      });
      
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message || 'Failed to search GOMS orders',
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      onError && onError(error);
    } finally {
      onComplete && onComplete();
    }
  };
